export default __webpack_public_path__ + "static/media/ume-journey.8d5ffdee.png";